import clsx from 'clsx';
import { useSelector } from 'react-redux';

import Icon from '@components/Icon/Icon';
import { EIcons } from '@enums/icons.enum';
import { EStyles } from '@enums/style.enum';
import type { RootState } from '@store/store';

import classes from './AppHeader.module.scss';

type Props = {
	goBack?: () => void;
	showBorder?: boolean;
};

export const AppHeader: React.FC<Props> = ({ goBack, showBorder = false }: React.PropsWithChildren<Props>) => {
	const flightNumber = useSelector((state: RootState) => state.trips.flightNumber);
	const airline = useSelector((state: RootState) => state.trips.airline);

	return (
		<div className={clsx(classes['headerContainer'], showBorder && classes['headerContainerBorder'])}>
			{goBack && (
				<button className={classes['backButtonContainer']} onClick={goBack}>
					<Icon name={EIcons.Back} size={22} color="var(--text)" />
				</button>
			)}
			<h1
				className={classes['title']}
			>{`${EStyles.hash}${flightNumber} ${airline ? `${EStyles.hyphen} ${airline}` : EStyles.emptyQuote}`}</h1>
		</div>
	);
};
